import { css } from 'linaria';

export const classNames = {
  root: css`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,
};
